import { render, staticRenderFns } from "./activityInformation.vue?vue&type=template&id=f15b560e&scoped=true&"
import script from "./activityInformation.vue?vue&type=script&lang=js&"
export * from "./activityInformation.vue?vue&type=script&lang=js&"
import style0 from "./activityInformation.vue?vue&type=style&index=0&id=f15b560e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15b560e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f15b560e')) {
      api.createRecord('f15b560e', component.options)
    } else {
      api.reload('f15b560e', component.options)
    }
    module.hot.accept("./activityInformation.vue?vue&type=template&id=f15b560e&scoped=true&", function () {
      api.rerender('f15b560e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/terminalActivity/components/activityInformation.vue"
export default component.exports